var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact"},[_c('TextPage',[_c('div',{staticClass:"copy-header"},[_c('div',{staticClass:"inner-copy"},[_c('p',{staticClass:"knuvu-title"},[_vm._v("Contact Information")]),_c('p',{staticClass:"knuvu-subtitle"},[_vm._v("KnuVu, LLC")]),_c('p',[_c('a',{attrs:{"href":"mailto:info@knuvu.com"}},[_vm._v("info@knuvu.com")])])])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }